import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import * as CounterpartySearchActions from './action';
import { CORE_API } from '../../../config';

export function* counterpartySearchFunc(action) {
    let requestUrl = `${CORE_API}/counterparty/search/${action.data.searchSelector}/${action.data.searchQuery}`;
    //console.log('searching counterparties with url =>', requestUrl);
    try {
        const searchResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(CounterpartySearchActions.counterpartySearchSuccess(searchResult));
    } catch (err) {
        yield put(CounterpartySearchActions.counterpartySearchFailure(err))
    }
}

export function* counterpartySearch() {
    yield takeLatest(CounterpartySearchActions.COUNTERPARTY_SEARCH, counterpartySearchFunc);
}

export function* updateCounterpartyDataFunc(action) {
    let requestUrl = `${CORE_API}/counterparty/updateCounterpartyData/${action.data.counterpartyId}`;
    try {
        const searchResult = yield call(request, requestUrl, { data: action.data.counterpartyData, method: 'PUT', headers: HTTP_HEADERS });
        yield put(CounterpartySearchActions.updateCounterpartyDataSuccess(searchResult));
    } catch (err) {
        yield put(CounterpartySearchActions.updateCounterpartyDataFailure(err))
    }
}

export function* updateCounterpartyData() {
    yield takeLatest(CounterpartySearchActions.UPDATE_COUNTERPARTY_DATA, updateCounterpartyDataFunc);
}

export function* updateCounterpartyMasterDataFunc(action) {
    let requestUrl = `${CORE_API}/masterdata/counterparty/updateMasterData/${action.data.counterpartyId}`;
    try {
        const searchResult = yield call(request, requestUrl, { data: action.data.counterpartyData, method: 'PUT', headers: HTTP_HEADERS });
        yield put(CounterpartySearchActions.updateCounterpartyMasterDataSuccess(searchResult));
    } catch (err) {
        yield put(CounterpartySearchActions.updateCounterpartyMasterDataFailure(err))
    }
}

export function* updateCounterpartyMasterData() {
    yield takeLatest(CounterpartySearchActions.UPDATE_COUNTERPARTY_MASTER_DATA, updateCounterpartyMasterDataFunc);
}